
(function () {
  var STORAGE_KEY = 'collection-view';
  var LIST_CLASS = 'collection-view-list';

  function applyView(view) {
    if (view === 'list') {
      document.body.classList.add(LIST_CLASS);
    } else {
      document.body.classList.remove(LIST_CLASS);
    }
  }

  function currentView() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function isCollectionOrSearchPage() {
    var path = window.location.pathname;
    return path.indexOf('/collections') === 0 || path.indexOf('/pages/search') === 0;
  }

  applyView(isCollectionOrSearchPage() ? currentView() : 'grid');

  if (!customElements.get('collection-view-toggle')) {
    customElements.define(
      'collection-view-toggle',
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = this.querySelectorAll('[data-view]');
          this.sync();
          this.buttons.forEach(function (btn) {
            btn.addEventListener('click', this.onClick.bind(this));
          }, this);
        }

        
        
        onClick(event) {
          var view = event.currentTarget.getAttribute('data-view');
          try {
            localStorage.setItem(STORAGE_KEY, view);
          } catch (e) {}
          applyView(view);
          this.sync();
        }

        sync() {
          var view = currentView();
          applyView(view);
          this.buttons.forEach(function (btn) {
            var isActive = btn.getAttribute('data-view') === view;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
      }
    );
  }
})();
